/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeStyles } from "@mui/styles";
import { IMG_GAIN_INTEREST } from "@config/images";

const useStyles = makeStyles((theme: any) => ({
  gainAccess: {
    // eslint-disable-next-line max-len
    backgroundImage: `linear-gradient(89.99deg, #272C2E 32.15%, rgba(77, 88, 94, 0.15) 99.99%), url("${IMG_GAIN_INTEREST}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  paper: {
    position: "absolute",
    width: "calc(100% - 20px)",
    maxWidth: "700px",
    backgroundColor: "#000",
    boxShadow: theme.shadows[5],
    outline: "none",
  },
  mediaHome: {
    maxWidth: 400,
    borderRadius: "24px",
    objectFit: "cover"
  },
  title: {
    fontSize: 32,
    lineHeight: "50px",
    marginBottom: 20,
  },
  titleReguler: {
    fontSize: 32,
    marginBottom: 28,
    lineHeight: "48px",
  },
}));

export default useStyles;
